package com.dotdrives.web.ui

import com.dotdrives.design.DotButtonVariant
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.span
import web.cssom.ClassName
import web.html.ButtonType
import web.html.button as buttonType

external interface DotButtonProps : Props {
    var text: String
    var onClick: (() -> Unit)?
    var type: ButtonType?
    var variant: DotButtonVariant?
    var enabled: Boolean?
    var loading: Boolean?
    var className: String?
}

val DotButton = FC<DotButtonProps> { props ->
    val variant = props.variant ?: DotButtonVariant.Primary
    val loading = props.loading == true
    val enabled = props.enabled != false
    val variantClass = when (variant) {
        DotButtonVariant.Primary -> "dot-button-primary"
        DotButtonVariant.Secondary -> "dot-button-secondary"
        DotButtonVariant.Tinted -> "dot-button-tinted"
        DotButtonVariant.Ink -> "dot-button-ink"
    }

    button {
        type = props.type ?: ButtonType.buttonType
        className = ClassName(
            listOfNotNull("dot-button", variantClass, props.className).joinToString(" "),
        )
        disabled = !enabled || loading
        ariaBusy = loading
        onClick = { props.onClick?.invoke() }

        if (loading) {
            span {
                className = ClassName("dot-spinner")
                ariaHidden = true
            }
        }
        +props.text
    }
}
